import { Toaster as Sonner } from 'sonner';

function Toaster() {
  return (
    <Sonner
      richColors
      theme="light"
      position="top-right"
      style={
        {
          '--success-bg': '#BBF7D0',
          '--success-text': '#09090B',
          '--success-border': '#E4E4E7',
          '--error-bg': '#DC2626',
          '--error-text': '#FFFFFF',
          '--error-border': '#DC2626',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          title: 'font-eurostile font-semibold text-sm',
          description: 'text-xs',
        },
      }}
      icons={{
        success: null,
        error: null,
        warning: null,
        info: null,
      }}
    />
  );
}

export { Toaster };
